import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import BillPrint from '../stocktransfer/Bill';
import ReactDOM from 'react-dom';
import '../shared.css';

const StockTransferCreate = () => {
    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();

    const [selectedBranch, setSelectedBranch] = useState("");
    const [dropdownBranchOptions, setDropdownBranchOptions] = useState([]);
    const [BranchData, setBranchData] = useState([]);
    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [itemdetails, setItemDetails] = useState([]);
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");
    const [isValid, setIsValid] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [modalData, setModalData] = useState({
        SlNo: '0', ItemName: '', ItemId: '', Quantity: '1',
        Rate: '', Amount: '', HSNCode: '', GSTRate: '',
        TaxableAmount: '', CGSTAmount: '', SGSTAmount: '', IGSTAmount: '', TotalAmount: '', balanceStock: 0,
    });

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        if (selectedBranch) {
            const selectedBranchData = BranchData.find(branch => branch.Id == selectedBranch);
            if (selectedBranchData) {
                setFormData(prev => ({ ...prev, GSTNumber: selectedBranchData.GSTNumber }));
            }
        }
    }, [selectedBranch, BranchData]);

    useEffect(() => {
        fetchDropdownBranchOptions();
        fetchmaxbillno();
        fetchItems();
    }, []);

    const fetchmaxbillno = () => {
        fetchData('StockTransferApi', `/MaxBillno/${companyId}/${branchId}`, token)
            .then(r => r.response_data)
            .then(data => setFormData(prev => ({ ...prev, BillNumber: data.BillNumber, BillPrefix: data.BillPrefix })))
            .catch(err => console.error('Error fetching Max Billno', err));
    };

    const fetchDropdownBranchOptions = () => {
        fetchData('StockTransferApi', `/Branch/${companyId}/${branchId}`, token)
            .then(r => r.response_data)
            .then(data => { setDropdownBranchOptions(data); setBranchData(data); })
            .catch(err => console.error('Error fetching Branch options:', err));
    };

    const fetchItems = async () => {
        try {
            const response = await fetchData('StockTransferApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({ value: item.Id, label: item.Code + '-' + item.Name }));
                setItemsrOptions(options);
                setItemDetails(response.response_data);
            }
            const d = new Date();
            const formattedDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            setFormData(prev => ({ ...prev, BillDate: formattedDate, FromBranchId: branchId, CompanyId: companyId, CreatedBy: userId }));
        } catch (err) { console.error('Error fetching items:', err); }
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        if (!selectedBranch) { setErrorMessage('Branch is required!'); setIsLoading(false); return; }
        if (!invoicedeatils || invoicedeatils.length === 0) { setErrorMessage('Item Details are required!'); setIsLoading(false); return; }

        setFormData(prev => ({ ...prev, ModifiedBy: userId, CompanyId: companyId, ToBranchId: selectedBranch, FromBranchId: branchId }));
        const CreateData = { StockTransfer: formData, StockTransferDetails: invoicedeatils };

        postData('StockTransferApi', CreateData, token)
            .then(response => {
                if (response.response === 'Stock Transfer Create Successfully') {
                    history.push(`/StockTransferDetails/${response.kotId}`);
                }
            })
            .catch(err => { console.error('Error creating record:', err); setIsLoading(false); });
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updated = [...invoicedeatils];
            updated.splice(index, 1);
            setInvoicedeatils(updated);
            recalcTotals(updated);
        }
    };

    const recalcTotals = (items) => {
        const Quantity = items.reduce((s, i) => s + parseFloat(i.Quantity), 0);
        const Amount = items.reduce((s, i) => s + parseFloat(i.Amount), 0);
        const TaxableAmount = items.reduce((s, i) => s + parseFloat(i.TaxableAmount), 0);
        const CGSTAmount = items.reduce((s, i) => s + parseFloat(i.CGSTAmount), 0);
        const SGSTAmount = items.reduce((s, i) => s + parseFloat(i.SGSTAmount), 0);
        const IGSTAmount = items.reduce((s, i) => s + parseFloat(i.IGSTAmount), 0);
        const TotalAmount = items.reduce((s, i) => s + parseFloat(i.TotalAmount), 0);
        totalCalculation(Quantity, Amount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount);
    };

    const totalCalculation = (Quantity, Amount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount) => {
        const netAmt = parseFloat(TaxableAmount) + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount);
        const roundOffValue = Math.round(netAmt) - netAmt;
        const totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);
        setFormData(prev => ({
            ...prev,
            TotalQuantity: Quantity,
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: parseFloat(totalAmt).toFixed(2),
            ModifiedBy: userId,
        }));
    };

    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        if (!selectedOption) return;
        const detail = itemdetails.find(i => i.Id === selectedOption.value);
        if (detail) {
            const qty = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(detail.PurchaseRate.toFixed(2)) || 0;
            const gstrate = parseFloat(detail.GSTRate.toFixed(2)) || 0;
            const taxable = (qty * rate).toFixed(2);
            let cgst = 0, sgst = 0, igst = 0;
            if (!formData.GSTNumber) {
                cgst = ((taxable * (gstrate / 2)) / 100).toFixed(2); sgst = cgst;
            } else {
                const p = formData.GSTNumber.toString().substring(0, 2);
                if (p !== branchstate) igst = ((taxable * gstrate) / 100).toFixed(2);
                else { cgst = ((taxable * (gstrate / 2)) / 100).toFixed(2); sgst = cgst; }
            }
            const total = Math.round((parseFloat(taxable) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));
            setModalData(prev => ({
                ...prev,
                Rate: rate.toFixed(2), GSTRate: gstrate.toFixed(2), HSNCode: detail.HSNCode,
                ItemName: selectedOption.label, ItemId: selectedOption.value,
                Amount: (qty * rate).toFixed(2), TaxableAmount: parseFloat(taxable).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2), SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2), TotalAmount: parseFloat(total).toFixed(2),
                balanceStock: detail.balanceStock,
            }));
        }
    };

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        const qty = parseFloat(value) || 0;
        if (name === 'Quantity') setIsValid(qty <= modalData.balanceStock);
        const rate = parseFloat(modalData.Rate) || 0;
        const gstrate = parseFloat(modalData.GSTRate) || 0;
        const taxable = (qty * rate).toFixed(2);
        let cgst = 0, sgst = 0, igst = 0;
        if (!formData.GSTNumber) {
            cgst = ((taxable * (gstrate / 2)) / 100).toFixed(2); sgst = cgst;
        } else {
            const p = formData.GSTNumber.toString().substring(0, 2);
            if (p !== branchstate) igst = ((taxable * gstrate) / 100).toFixed(2);
            else { cgst = ((taxable * (gstrate / 2)) / 100).toFixed(2); sgst = cgst; }
        }
        const total = Math.round((parseFloat(taxable) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));
        setModalData(prev => ({
            ...prev, [name]: value, Quantity: qty,
            Amount: (qty * rate).toFixed(2), TaxableAmount: parseFloat(taxable).toFixed(2),
            CGSTAmount: parseFloat(cgst).toFixed(2), SGSTAmount: parseFloat(sgst).toFixed(2),
            IGSTAmount: parseFloat(igst).toFixed(2), TotalAmount: parseFloat(total).toFixed(2),
        }));
    };

    const saveModalData = () => {
        if (!modalData.ItemId) { setErrorMessageModel("Item is required"); return; }
        if (!modalData.Quantity || isNaN(modalData.Quantity)) { setErrorMessageModel("Quantity must be a valid number"); return; }
        if (parseFloat(modalData.Quantity) > modalData.balanceStock) { setErrorMessageModel("Quantity exceeds available stock."); return; }
        setErrorMessageModel('');
        const updated = [modalData, ...invoicedeatils];
        setInvoicedeatils(updated);
        setModalData({ SlNo: '0', ItemName: '', ItemId: '', Quantity: '1', Rate: '', Amount: '', HSNCode: '', GSTRate: '', TaxableAmount: '', CGSTAmount: '', SGSTAmount: '', IGSTAmount: '', TotalAmount: '', balanceStock: 0 });
        setSelectedItem(null);
        recalcTotals(updated);
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    return (
        <Fragment>
            <div className="pg-container">

                {/* ── Header ── */}
                <div className="pg-header">
                    <h5 className="pg-title">Stock Transfer Out — Create</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            <button className="pg-btn pg-btn-gold" onClick={() => setIsModalOpen(v => !v)}>
                                <AddIcon /> Add Item
                            </button>
                            <button className="pg-btn pg-btn-success" onClick={handleSubmit} disabled={isLoading}>
                                <DoneIcon /> {isLoading ? <CircularProgress size={14} color="inherit" /> : 'Save'}
                            </button>
                            <Link to="/Home" className="pg-btn pg-btn-danger">
                                <CloseIcon /> Cancel
                            </Link>
                        </div>
                    </div>
                </div>

                {errorMessage && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
                {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

                <div className="pg-card">
                    {/* ── Header fields ── */}
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">To Branch <span className="req">*</span></span>
                            <select className="pg-hcell-input" value={selectedBranch}
                                onChange={e => {
                                    setSelectedBranch(e.target.value);
                                    setFormData(prev => ({ ...prev, ToBranchId: e.target.value }));
                                }}>
                                <option value="">Select Branch</option>
                                {dropdownBranchOptions.map(b => <option key={b.Id} value={b.Id}>{b.Name}</option>)}
                            </select>
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Date <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date"
                                value={formatDateForInput(formData.BillDate)} onChange={handleChange} name="BillDate" readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 100px' }}>
                            <span className="pg-hcell-label">Bill No</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.BillNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.TotalQuantity || ''} readOnly />
                        </div>
                    </div>

                    {/* ── Add Item bar (inline) ── */}
                    {isModalOpen && (
                        <div className="pg-item-bar" style={{ marginTop: 10 }}>
                            {errorMessageModel && <div className="pg-alert pg-alert-error" style={{ width: '100%', marginBottom: 6 }}>{errorMessageModel}</div>}
                            <div className="pg-field" style={{ flex: '3 1 0', minWidth: 220 }}>
                                <label className="pg-label">Item Name</label>
                                <Select
                                    value={selectedItems}
                                    onChange={handleItemSelect}
                                    options={itemsOptions}
                                    placeholder="Search item…"
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        control:    base => ({ ...base, minHeight: 31, height: 31, fontSize: 12.5 }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        menu:       base => ({ ...base, fontSize: 11.5 }),
                                        option:     base => ({ ...base, fontSize: 11.5, padding: '5px 10px' }),
                                    }}
                                />
                            </div>
                            <div className="pg-field narrow">
                                <label className="pg-label">Quantity</label>
                                <input className="pg-input text-right" type="number" name="Quantity"
                                    value={modalData.Quantity} onChange={handleModalInputChange} min={1} max={modalData.balanceStock} />
                                {!isValid && <span style={{ color: '#c0392b', fontSize: 10 }}>Exceeds stock</span>}
                            </div>
                            <div className="pg-field narrow">
                                <label className="pg-label">Rate</label>
                                <input className="pg-input text-right pg-input" type="text" value={modalData.Rate || ''} readOnly />
                            </div>
                            <div className="pg-field narrow">
                                <label className="pg-label">Amount</label>
                                <input className="pg-input text-right" type="text" value={modalData.TotalAmount || ''} readOnly />
                            </div>
                            <div style={{ display: 'flex', gap: 6, alignSelf: 'flex-end', paddingBottom: 2 }}>
                                <button className="pg-btn pg-btn-success" onClick={saveModalData}>Add</button>
                                <button className="pg-btn pg-btn-danger" onClick={() => setIsModalOpen(false)}>Cancel</button>
                            </div>
                        </div>
                    )}

                    {/* ── Invoice detail table ── */}
                    <div className="pg-invoice-table-wrap" style={{ marginTop: 10 }}>
                        <table className="pg-invoice-table">
                            <thead>
                                <tr>
                                    <th>Item Name</th>
                                    <th className="right">Quantity</th>
                                    <th className="right">Rate</th>
                                    <th className="right">Amount</th>
                                    <th className="right">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoicedeatils.length === 0
                                    ? <tr><td colSpan={5} style={{ textAlign: 'center', color: '#94a3b8', padding: 12 }}>No items added</td></tr>
                                    : invoicedeatils.map((inv, index) => (
                                        <tr key={index}>
                                            <td>{inv.ItemName}</td>
                                            <td className="right">{inv.Quantity}</td>
                                            <td className="right">{parseFloat(inv.Rate || 0).toFixed(2)}</td>
                                            <td className="right">{parseFloat(inv.TotalAmount || 0).toFixed(2)}</td>
                                            <td className="right">
                                                <IconButton size="small" onClick={() => removeRecord(index)}>
                                                    <DeleteIcon style={{ color: '#dc2626', fontSize: 16 }} />
                                                </IconButton>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>

                    {/* ── Totals ── */}
                    <div className="pg-totals-grid" style={{ marginTop: 8, gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr 1fr' }}>
                        <div className="pg-field">
                            <label className="pg-label">Remarks</label>
                            <input className="pg-input" type="text" name="Remarks"
                                value={formData.Remarks || ''} onChange={handleChange} placeholder="Remarks" />
                        </div>
                        <div className="pg-field">
                            <label className="pg-label">Amount</label>
                            <input className="pg-input text-right bold" type="text" value={formData.TaxableAmount || ''} readOnly />
                        </div>
                        <div className="pg-field">
                            <label className="pg-label">CGST</label>
                            <input className="pg-input text-right bold" type="text" value={formData.CGSTAmount || ''} readOnly />
                        </div>
                        <div className="pg-field">
                            <label className="pg-label">SGST</label>
                            <input className="pg-input text-right bold" type="text" value={formData.SGSTAmount || ''} readOnly />
                        </div>
                        <div className="pg-field">
                            <label className="pg-label">IGST</label>
                            <input className="pg-input text-right bold" type="text" value={formData.IGSTAmount || ''} readOnly />
                        </div>
                        <div className="pg-field">
                            <label className="pg-label">Round Off</label>
                            <input className="pg-input text-right bold" type="text" value={formData.RoundOff || ''} readOnly />
                        </div>
                        <div className="pg-field">
                            <label className="pg-label">Grand Total</label>
                            <input className="pg-input text-right bold grand-total" type="text" value={formData.GrandTotal || ''} readOnly />
                        </div>
                    </div>
                </div>

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
            </div>
        </Fragment>
    );
};

export default StockTransferCreate;
